const error = {
  api: {
    notfound: "La ressource demandée n'existe pas.",
    unauthorized: "Vous n'êtes pas autorisé à accéder à cette ressource.",
    unknown: 'Une erreur inattendue est survenue.',
  },
};

export default error;
